/**
 * 테마 정의 — Design §5.1
 *
 * 원본은 `storeData.theme` 값으로 런타임 전환하며, 실제 구현된 테마는
 * 'GOLDEN_YELLOW' 하나뿐이고 그 외 모든 값은 기본 테마로 폴백된다.
 * 이 폴백 동작을 그대로 유지한다.
 */

export const THEMES = ['default', 'golden-yellow'] as const

export type ThemeKey = (typeof THEMES)[number]

/** 서버가 내려주는 shopData.theme 값 → 테마 키 */
const SHOP_THEME_MAP: Record<string, ThemeKey> = {
  GOLDEN_YELLOW: 'golden-yellow',
}

export const DEFAULT_THEME: ThemeKey = 'default'

/** 알 수 없는 값은 조용히 기본 테마로 폴백 (원본 동작) */
export function resolveTheme(shopTheme: string | null | undefined): ThemeKey {
  if (!shopTheme) return DEFAULT_THEME
  return SHOP_THEME_MAP[shopTheme] ?? DEFAULT_THEME
}
